import { API_URL } from "@/constants/envVariables";

import { fetchApi } from "@/helpers/fetchApi";

export type RecoveryReportItem = {
  transactionId: number;
  organizationName?: string;
  userStellarAccount: string;
  email?: string;
  phoneNumber?: string;
  latestStatus: string;
  lastEventType: string;
  lastEventAt: string;
  lastActorRole: string;
  lastActorId?: string;
  usdcBalanceSnapshot?: string;
};

export type DataExplorerRecoveryResponse = {
  data: RecoveryReportItem[];
  pagination: {
    currentPage: number;
    limit: number;
    totalItems: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPrevPage: boolean;
  };
};

export const getDataExplorerRecovery = async (params?: {
  page?: number;
  limit?: number;
  q?: string;
}): Promise<DataExplorerRecoveryResponse> => {
  const searchParams = new URLSearchParams();
  if (params?.page) searchParams.set("page", String(params.page));
  if (params?.limit) searchParams.set("limit", String(params.limit));
  if (params?.q) searchParams.set("q", params.q);

  const qs = searchParams.toString();
  const url = `${API_URL}/admin/data-explorer/recovery${qs ? `?${qs}` : ""}`;

  return fetchApi(url) as Promise<DataExplorerRecoveryResponse>;
};
